export const ActionTypes = {
    SET_TABLE_DATA: "SET_TABLE_DATA",
  };